var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeezer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 76,
    viewBox: "0 0 116 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 0.52002H90.5195V15.01H115.35V0.52002Z",
    fill: "#29AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 20.7H90.5195V35.19H115.35V20.7Z",
    fill: "url(#paint0_linear_deezer)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 40.87H90.5195V55.36H115.35V40.87Z",
    fill: "url(#paint1_linear_deezer)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3398 61.05H0.509766V75.54H25.3398V61.05Z",
    fill: "url(#paint2_linear_deezer)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 61.05H30.5098V75.54H55.3398V61.05Z",
    fill: "url(#paint3_linear_deezer)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3495 61.05H60.5195V75.54H85.3495V61.05Z",
    fill: "url(#paint4_linear_deezer)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.35 61.05H90.5195V75.54H115.35V61.05Z",
    fill: "url(#paint5_linear_deezer)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3495 40.87H60.5195V55.36H85.3495V40.87Z",
    fill: "url(#paint6_linear_deezer)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 40.87H30.5098V55.36H55.3398V40.87Z",
    fill: "url(#paint7_linear_deezer)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3398 20.7H30.5098V35.19H55.3398V20.7Z",
    fill: "url(#paint8_linear_deezer)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_deezer",
    x1: 104.55,
    y1: 37.09,
    x2: 101.32,
    y2: 18.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C8C9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#298E9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#129C83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#05A475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A770"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_deezer",
    x1: 90.1495,
    y1: 54.63,
    x2: 115.72,
    y2: 41.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148CB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_deezer",
    x1: 0.509766,
    y1: 68.29,
    x2: 25.3398,
    y2: 68.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_deezer",
    x1: 30.5098,
    y1: 68.29,
    x2: 55.3398,
    y2: 68.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_deezer",
    x1: 60.5195,
    y1: 68.29,
    x2: 85.3495,
    y2: 68.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#472EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_deezer",
    x1: 90.5195,
    y1: 68.29,
    x2: 115.35,
    y2: 68.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2839BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3072B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_deezer",
    x1: 59.5395,
    y1: 52.03,
    x2: 86.3195,
    y2: 44.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4197C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_deezer",
    x1: 29.6398,
    y1: 43.28,
    x2: 56.2198,
    y2: 52.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D12F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_deezer",
    x1: 32.6098,
    y1: 18.4199,
    x2: 53.2398,
    y2: 37.4599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED743B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.18097c63.svg";
export { ForwardRef as ReactComponent };